// Default timeout for long-running report endpoints (milliseconds).
// Reports can be slow on the server, but past this point we assume the
// request is hung and reject it so the UI can recover.
export const REPORT_FETCH_TIMEOUT_MS = 60000;

export function fetchWithTimeout(input, init = {}, timeoutMs = REPORT_FETCH_TIMEOUT_MS) {
  const { signal: externalSignal, ...rest } = init;
  const controller = new AbortController();

  const timer = setTimeout(() => controller.abort(), timeoutMs);

  if (externalSignal) {
    if (externalSignal.aborted) {
      controller.abort();
    } else {
      externalSignal.addEventListener("abort", () => controller.abort(), { once: true });
    }
  }

  return fetch(input, { ...rest, signal: controller.signal })
    .catch((err) => {
      if (err && err.name === "AbortError") {
        if (externalSignal && externalSignal.aborted) {
          throw err;
        }
        const timeoutError = new Error("Request timed out. Please try again.");
        timeoutError.name = "TimeoutError";
        throw timeoutError;
      }
      throw err;
    })
    .finally(() => clearTimeout(timer));
}
